module.exports = __webpack_public_path__ + "img/icon_agent_en.ff2e094c.png";